import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { UserData } from './auth/userData';
import { Observable } from 'rxjs';
import { PermissionEnforcer } from './services/permission-enforcer.service';

@Injectable({
    providedIn: 'root',
})
export class RbacGuard implements CanActivate {
    constructor(
        private userData: UserData,
        private permissionEnforcer: PermissionEnforcer,
        private router: Router,
    ) {}

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const permissions = [];
        let permissionResults = [];
        let operator = null;
        if(Array.isArray(route.data.casbinArgs)) {
            permissions.push(route.data.casbinArgs);
        }
        else if(route.data.casbinArgs?.permissions) {
            permissions.push(...route.data.casbinArgs?.permissions);
            operator = route.data.casbinArgs?.operator;
        }

        permissionResults = permissions.map(([obj,act])=>{
            const hasPermission = this.permissionEnforcer.hasPermission(obj, act);
            return hasPermission;
        });

        if(operator === null) {
            return permissionResults[0];
        }
        else if(operator == 'or') {
            return permissionResults.includes(true);
        }
        else if(operator == 'and') {
            return !permissionResults.includes(false);
        }
        // const [obj, act] = route.data.casbinArgs;
        // console.log({ obj, act });
        // console.log(this.permissionEnforcer.enforce(obj, act));
        // if (this.permissionEnforcer.permissions.length === 0) {
        //     await this.permissionEnforcer.loadPermissions().toPromise();
        // }

    }
}
